<template>
    <PaymentCardContainer
        :accounts="pluginProjects"
    ></PaymentCardContainer>
</template>

<script>
import store from '@/store'
import PaymentCardContainer from '@/modules/PaymentCard'
import PaymentCardStore from '@/modules/PaymentCard/_store'
import { getCurrentInstance, computed } from '@vue/composition-api'
import { CREDIT_CARD_USER } from '@/service'
const STORE_KEY = '$_payment_card'
export default {
    components: {
        PaymentCardContainer
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const userRights = computed(() => store.getters.userRights)
        const pluginProjects = computed(() => userRights.value.find(item => item.serviceName === CREDIT_CARD_USER).projects)
        const projectIdxs = pluginProjects.value.map(item => item.projectIdx)
        const usageAccountIds = pluginProjects.value.map(item => item.usageAccountId)
        store.dispatch(`${STORE_KEY}/fetchAssignedCardAccounts`, { projectIdxs, usageAccountIds })

        return {
            pluginProjects
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, PaymentCardStore)
        }
        next()
    }
}
</script>

<style>

</style>
